import axios from 'axios';
import _ from 'lodash';
import api from '../api';
import helper from '../helper';

const actions = {
  getInitialApiData: ({ state, commit }) => {
    commit('setLoadingInitialApiData', true);
    axios.all([
      api.get('lookups'),
      api.get('SPGSLink'),
      api.get('LPGSLink'),
      api.get('footnotes'),
    ])
      .then(axios.spread((lookups, sp, lp, fn) => {
        const lookupTypes = _(lookups.data).map('type').uniq().value();
        // returns object keyed by lookup type containing object keyed by id
        // containing object with id, name, abbr (if exists), sort
        const lku = _(lookupTypes).reduce((acc, type) => {
          acc[type] = _(lookups.data).filter({ type })
            .map(item => _.pick(item, ['id', 'name', 'abbr', 'sort', 'parent']))
            .keyBy('id')
            .value();
          return acc;
        }, {});
        commit('setLku', lku);
        commit('setSPGSLink', sp.data);
        commit('setLPGSLink', lp.data);
        commit('setFootnotes', fn.data);
        let dataErrors = [];
        dataErrors = dataErrors.concat(helper.checkForMissingLookupTypes(state.lku));
        dataErrors = dataErrors.concat(helper.checkForMissingLookupIdsInSPGSLink(
          state.lku,
          state.spgsLink,
        ));
        dataErrors = dataErrors.concat(helper.checkForMissingLookupIdsInLPGSLink(
          state.lku,
          state.lpgsLink,
        ));
        dataErrors = dataErrors.concat(helper
          .checkForMissingDataGuideRowInFootnotes(state.footnotes));
        if (dataErrors.length) {
          dataErrors.forEach((error) => {
            commit('addDataError', error);
          });
        }
        commit('setLoadingInitialApiData', false);
      }))
      .catch((err) => {
        commit('setLoadingInitialApiData', false);
        commit('addApiError', err);
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js